import { createFileRoute } from "@tanstack/react-router";
import AdminMicrosites from "@/pages/admin/AdminMicrosites";

export const Route = createFileRoute("/_adminLayout/admin/microsites")({
  head: () => ({ meta: [
    { title: "Microsite Builder | Rex & Sons RVs Admin" },
    { name: "description", content: "Build and edit microsite pages with AI suggestions and reusable templates." },
    { property: "og:title", content: "Rex & Sons RVs Microsite Builder" },
    { property: "og:description", content: "Manage microsite drafts, templates and releases." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
  ] }),
  component: AdminMicrosites,
});
